import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

//dropdown APLICACIONES
const DetalleNivelAP1 = props => { 
  return (
    // <option dato1={props.elemento.descrAplicacion} dato2={props.elemento.color} value={props.elemento._id}>{props.elemento.descrAplicacion}</option>
    <option>{props.elemento.descrAplicacion}</option>
  )    
}

const ListaAP = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelAP1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrAplicacion" id="miLista5" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown APLICACIONES
//dropdown PRUEBAS
const DetalleNivelPR1 = props => {
  return (
    <option dato1={props.elemento.descrPrueba} 
    dato2={props.elemento.tipoPrueba} 
    dato3={props.elemento.unidad} 
    dato4={props.elemento.validacion} 
    dato5={props.elemento.codNorma?props.elemento.codNorma:''} 
    dato6={props.elemento.descripcion?props.elemento.descripcion:''} 
    dato7={props.elemento.metodo?props.elemento.metodo:''} 
    value={props.elemento._id}>{props.elemento.descrPrueba}</option>
  )
};

const ListaPR = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelPR1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrPrueba" id="miLista6" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown PRUEBAS

class ConfSimAlar2 extends React.Component {
  state={argsDocum: {}, listAp: []}

  handleChange = async (ev)=>{
    ev.preventDefault()

    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value

    if(ev.target.name === "descrAplicacion"){
      let miLista = document.getElementById("miLista5");
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        argsDocum['descrAplicacion'] = miLista.options[miLista.selectedIndex].value
      }else{
        delete argsDocum.descrAplicacion
      }
      this.setState({argsDocum});
    }else{
      let miLista6 = document.getElementById("miLista6");
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        argsDocum['descrPrueba'] = miLista6.options[miLista6.selectedIndex].attributes[0].value
        argsDocum['tipoPrueba'] = miLista6.options[miLista6.selectedIndex].attributes[1].value
        argsDocum['unidad'] = miLista6.options[miLista6.selectedIndex].attributes[2].value
        argsDocum['validacion'] = miLista6.options[miLista6.selectedIndex].attributes[3].value
        argsDocum['codNorma'] = miLista6.options[miLista6.selectedIndex].attributes[4].value?miLista6.options[miLista6.selectedIndex].attributes[4].value:''
        argsDocum['descripcion'] = miLista6.options[miLista6.selectedIndex].attributes[5].value?miLista6.options[miLista6.selectedIndex].attributes[5].value:''
        argsDocum['metodo'] = miLista6.options[miLista6.selectedIndex].attributes[6].value?miLista6.options[miLista6.selectedIndex].attributes[6].value:''
      }else{
        delete argsDocum.descrPrueba
        delete argsDocum.tipoPrueba
        delete argsDocum.unidad
        delete argsDocum.validacion
        delete argsDocum.codNorma
        delete argsDocum.descripcion
        delete argsDocum.metodo
      }
      this.setState({argsDocum});
    }
  }

  handleSubmit = async (ev)=>{
    let argsDocum = this.state.argsDocum
    let alarma1=''
    let alarma2=''
    let alarma3=''
    let corte1=''
    let corte2=''
    let corte3=''
    let mensajeA=''
    let mensajeC=''
    let mensajeP=''
    let tipo=''
    let unidad=''
    let validacion=''
    let norma=''
    let descripcion=''
    let metodo=''

    if(argsDocum.descrAplicacion && argsDocum.descrPrueba){
      if(argsDocum.validacion === "No se compara"){
        mensajeA="ESTA PRUEBA NO SE EVALUA, NO TIENE VALORES DE REFERENCIA"
      }else{
        let prueba=this.props.list2

        switch (argsDocum.descrPrueba) {
          case 'Color':
            mensajeA = `Mayores que: 4 y Menores o igual que: 6`
            mensajeC = `Mayores que: 6`
            mensajeP = `Mayores que: 2 y Menores o igual que 4`
            break;
          case 'Ruler %':
            mensajeA = `Mayores que: 25 y Menores o igual que: 50`
            mensajeC = `Menores o igual que: 25`
            mensajeP = `Mayores que: 50 y Menores o igual que 75`
            break;
          case 'Ruler Aminas':
            mensajeA = `Mayores que: 25 y Menores o igual que: 50`
            mensajeC = `Menores o igual que: 25`
            mensajeP = `Mayores que: 50 y Menores o igual que 75`
            break;
          case 'Ruler Fenoles':
            mensajeA = `Mayores que: 25 y Menores o igual que: 50`
            mensajeC = `Menores o igual que: 25`
            mensajeP = `Mayores que: 50 y Menores o igual que 75`
            break;
          case 'Ruler ZDDP':
            mensajeA = `Mayores que: 25 y Menores o igual que: 50`
            mensajeC = `Menores o igual que: 25`
            mensajeP = `Mayores que: 50 y Menores o igual que 75`
            break;
          case 'Prueba de oxidación de recipientes a presión giratorios RPVOT':
            mensajeA = `Mayores que: 25% y Menores o igual que: 50% sobre el valor de aceite nuevo`
            mensajeC = `Menores o igual que: 25% sobre el valor de aceite nuevo`
            mensajeP = `Mayores que: 50% y Menores o igual que 75% sobre el valor de aceite nuevo`
            break;
          case 'Barnices Potencial (MPC)':
            mensajeA = `ΔE Mayores que: 30 y Menores o igual que: 40`
            mensajeC = `ΔE Mayores que: 40`
            mensajeP = `ΔE Mayores que: 15 y Menores o igual que 30`
            break;
          case 'Demulsibilidad Aceite':
            mensajeA = `Menores que: 32 y Mayores o igual que: 24`
            mensajeC = `Menores que: 24`
            mensajeP = `Menores que: 40 y Mayores o igual que 32`
            break;
          case 'Demulsibilidad Agua':
            mensajeA = `Menores que: 32 y Mayores o igual que: 24`
            mensajeC = `Menores que: 24`
            mensajeP = `Menores que: 40 y Mayores o igual que 32`
            break;
          case 'Demulsibilidad Emulsión':
            mensajeA = `Mayores que: 8 y Menores o igual que: 12`
            mensajeC = `Mayores que: 12`
            mensajeP = `Mayores que: 0 y Menores o igual que 8`
            break;
          case 'Demulsibilidad Tiempo':
            mensajeA = `Mayores que: 36 y Menores o igual que: 42`
            mensajeC = `Mayores que: 42`
            mensajeP = `Mayores que: 30 y Menores o igual que 36`
            break;              
          case 'Espumas Secuencia I (0.0 min) Tendencia':
            mensajeA = `Mayores que: 360 y Menores o igual que: 450`
            mensajeC = `Mayores que: 450`
            mensajeP = `Mayores que: 300 y Menores o igual que 360`
            break;                  
          case 'Espumas Secuencia I (10 min) Estabilidad':
            mensajeA = `Mayores que: 6 y Menores o igual que: 10`
            mensajeC = `Mayores que: 10`
            mensajeP = `Mayores que: 0 y Menores o igual que 6`
            break;
          case 'Espumas Secuencia II (0.0 min) Tendencia':
            mensajeA = `Mayores que: 450 y Menores o igual que: 500`
            mensajeC = `Mayores que: 500`
            mensajeP = `Mayores que: 400 y Menores o igual que 450`
           break;
          case 'Espumas Secuencia II (10 min) Estabilidad':
            mensajeA = `Mayores que: 6 y Menores o igual que: 10`
            mensajeC = `Mayores que: 10`
            mensajeP = `Mayores que: 0 y Menores o igual que 6`
            break;
          case 'Espumas Secuencia III (0.0 min) Tendencia':
            mensajeA = `Mayores que: 360 y Menores o igual que: 450`
            mensajeC = `Mayores que: 450`
            mensajeP = `Mayores que: 300 y Menores o igual que 360`
            break;              
          case 'Espumas Secuencia III (10 min) Estabilidad':
            mensajeA = `Mayores que: 6 y Menores o igual que: 10`
            mensajeC = `Mayores que: 10`
            mensajeP = `Mayores que: 0 y Menores o igual que 6`
            break;                  
          case 'Liberación de aire':
            mensajeA = `Mayores que: 20 y Menores o igual que: 30`
            mensajeC = `Mayores o igual que: 30`
            mensajeP = `Mayores que: 10 y Menores o igual que 20`
            break;
          case 'Punto de inflamación':
            mensajeA = `Entre el +/- 15% y +/- 20% del valor del aceite nuevo`
            mensajeC = `Mayor +/- 20% del valor del aceite nuevo`
            break;              
          case 'Corrosión en lamina de cobre':
            mensajeA = `(3a-3b)`
            mensajeC = `(4a-4b-4c)`
            break;                  
          case 'Ultracentrifuga':
            mensajeA = `Mayores que: 6 y Menores o igual que: 8`
            mensajeC = `Mayores que: 8`
            mensajeP = `Mayores que: 4 y Menores o igual que 6`
            break;
          case 'Densidad a 15°C':
            break;
          case 'Apariencia':
            break;
          case 'Olor':
            break;              
          case 'Punto de fuego':
            mensajeA = `Entre el +/- 15% y +/- 20% del valor del aceite nuevo`
            mensajeC = `Mayor +/- 20% del valor del aceite nuevo`
            break;           
          default:
            let listPr = this.props.list2.filter(elemento => elemento.descrPrueba===argsDocum.descrPrueba)
            listPr[0].pruebaslab.forEach((valRef, _id) => {
              if(valRef.descrAplicacion===argsDocum.descrAplicacion){
                if(valRef.valor3Alarma!=='' && valRef.valor3Alarma!==null){
                  mensajeA = `Mayores que :  ${valRef.valor1Alarma}/${valRef.valor2Alarma}/${valRef.valor3Alarma}`
                  mensajeC = `Mayores que:  ${valRef.valor1Corte}/${valRef.valor2Corte}/${valRef.valor3Corte}`
                }else{
                  if(valRef.valor2Alarma!=='' && valRef.valor2Alarma!==null){
                    mensajeA = `Mayores que: ${valRef.valor1Alarma} y Menores que: ${valRef.valor2Alarma}`
                    mensajeC = `Mayores que: ${valRef.valor1Corte} y Menores que ${valRef.valor2Corte}`
                  }else{
                    mensajeA = `Mayores que: ${valRef.valor1Alarma}`
                    mensajeC = `Mayores que: ${valRef.valor1Corte}`
                  } 
                }
              }  
            })
            break;
        }
        
      }
      
      let mensajePTit = 'VALORES PARA PRECAUCION'
      let mensajeATit = 'VALORES PARA ALARMA'
      let mensajeCTit = 'VALORES PARA PELIGRO'
      let tipoTit = 'TIPO DE PRUEBA'
      let unidadTit = 'UNIDAD'
      let validacionTit = 'TIPO DE VALIDACION'
      let normaTit = 'NORMA'
      let descripcionTit = 'DESCRIPCION DE LA PRUEBA'
      let metodoTit = 'METODO'
      tipo = argsDocum.tipoPrueba
      unidad = argsDocum.unidad
      validacion = argsDocum.validacion
      norma = argsDocum.codNorma
      descripcion = argsDocum.descripcion?argsDocum.descripcion:''
      metodo = argsDocum.metodo?argsDocum.metodo:''

      document.getElementById('lbMensajePTit').innerHTML = mensajePTit
      let lbMensajePTit = document.getElementById('lbMensajePTit').innerHTML
      document.getElementById('lbMensajeATit').innerHTML = mensajeATit
      let lbMensajeATit = document.getElementById('lbMensajeATit').innerHTML
      document.getElementById('lbMensajeCTit').innerHTML = mensajeCTit
      let lbMensajeCTit = document.getElementById('lbMensajeCTit').innerHTML
      document.getElementById('lbTipoTit').innerHTML = tipoTit
      let lbTipoTit = document.getElementById('lbTipoTit').innerHTML
      document.getElementById('lbUnidadTit').innerHTML = unidadTit
      let lbUnidadTit = document.getElementById('lbUnidadTit').innerHTML
      document.getElementById('lbValidacionTit').innerHTML = validacionTit
      let lbValidacionTit = document.getElementById('lbValidacionTit').innerHTML
      document.getElementById('lbNormaTit').innerHTML = normaTit
      let lbNormaTit = document.getElementById('lbNormaTit').innerHTML
      document.getElementById('lbDescripcionTit').innerHTML = descripcionTit
      let lbDescripcionTit = document.getElementById('lbDescripcionTit').innerHTML
      document.getElementById('lbMetodoTit').innerHTML = metodoTit
      let lbMetodoTit = document.getElementById('lbMetodoTit').innerHTML

      document.getElementById('lbMensajeP').innerHTML = mensajeP
      let lbMensajeP = document.getElementById('lbMensajeP').innerHTML
      document.getElementById('lbMensajeA').innerHTML = mensajeA
      let lbMensajeA = document.getElementById('lbMensajeA').innerHTML
      document.getElementById('lbMensajeC').innerHTML = mensajeC
      let lbMensajeC = document.getElementById('lbMensajeC').innerHTML
      document.getElementById('lbTipo').innerHTML = tipo
      let lbTipo = document.getElementById('lbTipo').innerHTML
      document.getElementById('lbUnidad').innerHTML = unidad
      let lbUnidad = document.getElementById('lbUnidad').innerHTML
      document.getElementById('lbValidacion').innerHTML = validacion
      let lbValidacion = document.getElementById('lbValidacion').innerHTML
      document.getElementById('lbNorma').innerHTML = norma
      let lbNorma = document.getElementById('lbNorma').innerHTML
      document.getElementById('lbDescripcion').innerHTML = descripcion
      let lbDescripcion = document.getElementById('lbDescripcion').innerHTML
      document.getElementById('lbMetodo').innerHTML = metodo
      let lbMetodo = document.getElementById('lbMetodo').innerHTML
    }else{
      alert("Datos incompletos para generar los valores de alarma")
    }
  }

  

  render(){
    // const {listAp} = this.state;
    let listAp = []

    listAp = this.props.list.filter(elemento => elemento.tipoLub==="Aceite")

    return (

      <div>
        <List selection>
          {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
          <TitDer textBoton1="Simulador de alarmas " btnNuevo={"NO"} styles={this.props.styles}/>

          {/* <div> */}
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev)}>   
              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Aplicación</label>
                      <ListaAP list={listAp} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Prueba de laboratorio</label>
                      <ListaPR list={this.props.list2} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                </div>
              </div>
              <p></p>
              <div className="ui one column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '100%'}}>
                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                    Ver valores de alarma
                  </Button>
                  </div>
                </div>
              </div>
              <p></p>
              <hr></hr>

              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbTipoTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbTipo" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbNormaTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbNorma" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
                <div className="row container">
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbDescripcionTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbDescripcion" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMetodoTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMetodo" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
                <div className="row container">                  
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbUnidadTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbUnidad" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbValidacionTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbValidacion" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
                <div className="row container">  
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajePTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeP" type='button' fluid></Button>
                    </Form.Field>
                  </div>                     
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajeATit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeA" type='button' fluid></Button>
                    </Form.Field>
                  </div>                
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajeCTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeC" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
              </div>
              
            </Form>
          </div>
        </List>
      </div>
    )
  }
};

export default compose( 
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  // graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
)(ConfSimAlar2)
